export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxQlgc_SjTjQJElti5.7cc14f66.woff2";